import React from 'react';
import { Col, Row } from 'reactstrap';
import moment from 'moment/moment';
import i18n from "../../../i18next";

import SectionTitle from './SectionTitle';
import SearchButton from './SearchButton';
import TableSection from './TableSection';

const TableCard = props => {

    const { colContainerStyle, mainItem, flexSpace, restaurantMainItem, datesStyle, noDataMessageStyle } = styles;
    const dates = `${moment(props.content.fromDate, moment.defaultFormat).format('DD/MM/YY')}-${moment(props.content.toDate, moment.defaultFormat).format('DD/MM/YY')}`;
    const isType = props.type === 'restaurantSourceTypes' || props.type === 'restaurantPaymentTypes' || props.type === "restaurantOrderTypes";
    
    const renderNoDataMessage = () => {
        if(props.insightType === 'restaurant') {
            return (
                <div style={noDataMessageStyle}>
                    {i18n.t('screens:restaurantInsightScreen.noData')}
                </div>
            )
        }
    };


    return (
        <Col style={colContainerStyle} sm={props.colSize}>
            <div style={props.insightType === 'restaurant' ? restaurantMainItem : mainItem } className="thinScrollbar">
                <div style={flexSpace}>
                    <SectionTitle title={props.title} />
                    <SearchButton onClick={props.toggleModal} />
                </div>
                {props.chartType ? props.chartType : renderNoDataMessage()}
                {isType ? <Row style={datesStyle} >{i18n.t('screens:restaurantInsightScreen.showingDataForPeriod')} {dates}</Row> : null}
                <TableSection type={props.type} content={props.content} currency={props.currency}/>
            </div>
        </Col>

    );
}

export default TableCard;

const styles = {
    colContainerStyle: {
        padding: '10px'
    },
    mainItem: {
        height: '250px',
        backgroundColor: 'white',
        overflow: 'auto'
    },
    restaurantMainItem: {
        //height: '559px',
        height: '466px',
        backgroundColor: 'white',
        overflow: 'auto'
    },
    flexSpace: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: '5px'
    },
    datesStyle: {
        display: 'flex', 
        justifyContent: 'center', 
        fontSize: '12px', 
        fontWeight: 'bold', 
        margin: '11px 0px 0px 0px',
        width: '100%'
    },
    noDataMessageStyle: {
        height: '66%', 
        color: 'rgb(195, 195, 195)', 
        textAlign: 'center', 
        paddingLeft: '35px', 
        paddingRight: '35px', 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        fontStyle: 'inherit', 
        fontSize: '15px'
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/customerInsightScreen/TableCard.js